// extracted by mini-css-extract-plugin
module.exports = {"desktop":"1025","numImagesShown":"3","totalImages":"6","galleryIndex":"-1"};